.refCard {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 2rem 0.5rem 1rem;
    border: 1px solid #e0e4ed;
    border-radius: 0.25rem;
    color: #012c3d;
    text-decoration: none;
    background: white;
    max-width: 100%;
}

.refCard:hover {
    background-color: #e0e4ed;
}

.refBadge {
    display: inline-block;
    background: hsl(196, 35%, 92%);
    color: hsl(197, 97%, 12%);
    border-radius: 0.25rem;
    font-size: 0.75rem;
    letter-spacing: 0.5px;
    margin-right: 0.5rem;
    padding: 0.25rem 0.5rem;
    text-transform: uppercase;
}

.fileIcon {
    flex-shrink: 0;
    width: 1.5rem;
    height: 1.5rem;
}

.downloadIcon {
    flex-shrink: 0;
    width: 1.5rem;
    height: 1.5rem;
    color: #939aaf;
    display: none;
}

.refCard:hover .downloadIcon {
    display: inline-block;
}

.refCard:hover .fileIcon {
    display: none;
}

.externalLinkIcon {
    flex-shrink: 0;
    width: 1rem;
    height: 1rem;
    color: #939aaf;
}

.refLabel {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
